export default __webpack_public_path__ + "static/flowizeicon-260bda05830aa942d57d32355a0a94fa.svg";